/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgObjectClassification = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 2h8v8h-3v1h6v3h3v8h-8v-8h3v-1H7v1.336l3.54 3.539L6 22.415l-4.54-4.54L5 14.335V11h6v-1H8V2zM6 16.164l-1.71 1.711L6 19.585l1.71-1.71L6 16.165zM10 4v4h4V4h-4zm6 12v4h4v-4h-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgObjectClassification as ObjectClassification };
